<template>
  <div class="content-page" v-if="applitInfo">
    <div class="bd">
      <div class="content">
        <div class="content-container">
          <el-form ref="form" label-position="right" label-width="180px">
            <el-form-item label="小程序码：">
              <div class="form-inline-content flex">
                <div class="inside-content center" v-if="publishQrCode">
                  <qrcode
                    v-if="publishQrCode"
                    :value="publishQrCode"
                    :options="{ size: 500 }"
                    class="scan-code-img"
                    id="publishcode"
                  ></qrcode>
                  <div>
                    <el-button
                      type="primary"
                      size="small"
                      @click="downCode('publishcode')"
                      >下载小程序码</el-button
                    >
                  </div>
                </div>
                <div class="inside-content center" v-else>
                  <div>
                    <el-button type="primary" size="small" @click="bindCode(1)"
                      >绑定小程序码</el-button
                    >
                  </div>
                </div>
              </div>
            </el-form-item>
            <el-form-item label="收款码：">
              <div class="form-inline-content flex">
                <div class="inside-content center" v-if="publishPayQrCode">
                  <qrcode
                    v-if="publishPayQrCode"
                    :value="publishPayQrCode"
                    :options="{ size: 500 }"
                    class="scan-code-img"
                    id="paycode"
                  ></qrcode>
                  <div>
                    <el-button
                      type="primary"
                      size="small"
                      @click="downCode('paycode')"
                      >下载收款码</el-button
                    >
                  </div>
                </div>
                <div class="inside-content center" v-else>
                  <div>
                    <el-button type="primary" size="small" @click="bindCode(2)"
                      >绑定收款码</el-button
                    >
                  </div>
                </div>
              </div>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </div>
    <el-dialog
      :visible.sync="dialogBindCodeVisible"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="510px"
    >
      <div slot="title" class="dialog-title">
        绑定二维码
      </div>
      <el-form
        :model="bindCodeForm"
        :rules="bindCodeFormRule"
        ref="bindCodeForm"
        label-width="68px"
        class="demo-ruleForm"
        :hide-required-asterisk="true"
      >
        <el-form-item label="绑定号码" prop="tableName">
          <el-input
            v-model="bindCodeForm.bindCode"
            :maxlength="8"
            placeholder="请填写二维码绑定号码"
            type="number"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          @click="bindCodeConfirm"
          :loading="isSubmit"
          >{{ "立即绑定" }}</el-button
        >
        <el-button @click="dialogBindCodeVisible = false">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { bindWhdcQrCode, whdcQrCode } from "@/api";
import { commonFuc } from "@/mixins/commonFuc";
import { mapState } from "vuex";
import qrcode from "@xkeshi/vue-qrcode";

export default {
  mixins: [commonFuc],
  data() {
    return {
      publishQrCode: "",
      publishPayQrCode: "",
      dialogBindCodeVisible: false,
      codeType: 1,
      bindCodeForm: {
        bindCode: "",
      },
      bindCodeFormRule: {
        bindCode: [
          {
            required: true,
            message: "请输入二维码绑定号码",
            trigger: "blur",
          },
        ],
      },
      isSubmit: false,
    };
  },
  computed: {
    ...mapState({
      applitInfo: (state) => state.applitInfo,
    }),
  },
  components: {
    qrcode,
  },
  watch: {},
  mounted() {
    this.getPageData();
  },
  methods: {
    getPageData() {
      this.addQrCodeJumpIndex();
      this.addQrCodeJumpPay();
    },
    addQrCodeJumpIndex() {
      whdcQrCode({
        mtype: 1,
      }).then((res) => {
        if (res.code == 1) {
          this.publishQrCode = res.data.url;
        }
      });
    },
    addQrCodeJumpPay() {
      whdcQrCode({
        mtype: 2,
      }).then((res) => {
        if (res.code == 1) {
          this.publishPayQrCode = res.data.url;
        }
      });
    },
    downCode(name) {
      let canvas = document.getElementById(name);
      let dataURL = canvas.toDataURL("image/png");
      let a = document.createElement("a"); // 创建一个a节点插入的document
      let event = new MouseEvent("click"); // 模拟鼠标click点击事件
      a.download = `${name}.png`; // 设置a节点的download属性值
      a.href = dataURL; // 将图片的src赋值给a节点的href
      a.dispatchEvent(event);
    },
    bindCode(type) {
      this.codeType = type;
      this.dialogBindCodeVisible = true;
    },
    copy() {
      var copyText = document.querySelector(`.publishQrCode`);
      copyText.select();
      document.execCommand("copy");
      this.$notify({
        title: "提示",
        message: "复制成功",
        type: "success",
        duration: 1000,
      });
    },
    bindCodeConfirm() {
      this.$refs.bindCodeForm.validate((valid) => {
        if (valid) {
          this.isSubmit = true;
          bindWhdcQrCode({
            mtype: this.codeType,
            qrCodeNo: this.bindCodeForm.bindCode,
          }).then((res) => {
            if (res.code == 1) {
              this.getPageData();
              this.dialogBindCodeVisible = false;
            } else {
              this.$notify({
                title: "提示",
                message: res.msg,
                type: "error",
                duration: 2000,
              });
            }
            this.isSubmit = false;
          });
        } else {
          this.$notify({
            title: "提示",
            message: "请完善提交内容",
            type: "error",
            duration: 2000,
          });
          return false;
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.publishQrCode {
  position: absolute;
  top: 0;
  left: 0;
  opacity: 0;
}
.content-page {
  height: 100%;
  overflow: hidden;
  .bd {
    height: 100%;
    padding: 20px;
    .el-form-item {
      margin: 25px 0;
      .form-inline-content {
        border-bottom: 1px solid #d8d8d8;
        min-height: 40px;
        padding-bottom: 24px;
        &.flex {
          display: flex;
          .inside-content + .inside-content {
            margin-left: 50px;
          }
        }
        .flex-row-start {
          display: flex;
          flex-direction: row;
          justify-content: flex-start;
        }
        .inside-content {
          &.center {
            text-align: center;
          }
          .flex-column-around {
            display: flex;
            flex-direction: column;
            justify-content: space-around;
            padding-left: 60px;
            box-sizing: border-box;
          }
          .scan-code-img {
            display: inline-block;
            // width: 100px;
            height: 100px;
          }
          .avatar {
            width: 50px;
            height: 50px;
            border-radius: 50%;
          }
          .el-input,
          .el-select {
            width: 300px;
            margin-right: 10px;
          }
        }
      }
    }
  }
}
</style>
